import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'usehooks-ts'

import { CabinetLink, useAuth } from '@features/auth'
import { FavoriteNavButton } from '@features/favorite'
import useModalStore from '@features/modal/model'
import { SearchInput } from '@features/search'

import { ModalCategories } from '@widgets/modal-categories'

import { cn } from '@shared/lib/cn'
import Button from '@shared/ui/button'

import styles from './StickyHeader.module.scss'

interface StickyHeaderProps {
  isVisible?: boolean;
}

export default function StickyHeader ({ isVisible = false }: StickyHeaderProps) {
  const { t: tn } = useTranslation('navigation')
  const { openModal } = useModalStore()
  const { user } = useAuth()
  const isTablet = useMediaQuery('(max-width: 1179.9px)')

  // Скрываем на планшетах/мобильных
  if (isTablet) {
    return null
  }

  return (
    <div className={cn(styles.root, { [styles['root--visible']]: isVisible })}>
      <Button
        className={styles.root__catalog}
        size="medium"
        onClick={() =>
          openModal('categories', <ModalCategories />, {
            hideIconClose: true,
            disabledScroll: true,
          })
        }
      >
        <img
          src="/icons/grid.svg"
          alt=""
          loading="lazy"
          fetchPriority="low"
        />
        {tn('catalog')}
      </Button>

      <SearchInput className={styles.root__search} />

      {user && <FavoriteNavButton className={styles.root__favorite} />}

      <CabinetLink className={styles.root__cabinet} />
    </div>
  )
}
